var $ac03861c6e8605f4$exports = {};
$ac03861c6e8605f4$exports = {
  "ascending": "\u03B1\u03CD\u03BE\u03BF\u03C5\u03C3\u03B1",
  "ascendingSort": function ascendingSort(args) {
    return "\u03B4\u03B9\u03B1\u03BB\u03BF\u03B3\u03AE \u03B1\u03BD\u03AC \u03C3\u03C4\u03AE\u03BB\u03B7 ".concat(args.columnName, " \u03C3\u03B5 \u03B1\u03CD\u03BE\u03BF\u03C5\u03C3\u03B1 \u03C3\u03B5\u03B9\u03C1\u03AC");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixel");
  },
  "descending": "\u03C6\u03B8\u03AF\u03BD\u03BF\u03C5\u03C3\u03B1",
  "descendingSort": function descendingSort(args) {
    return "\u03B4\u03B9\u03B1\u03BB\u03BF\u03B3\u03AE \u03B1\u03BD\u03AC \u03C3\u03C4\u03AE\u03BB\u03B7 ".concat(args.columnName, " \u03C3\u03B5 \u03C6\u03B8\u03AF\u03BD\u03BF\u03C5\u03C3\u03B1 \u03C3\u03B5\u03B9\u03C1\u03AC");
  },
  "resizerDescription": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C4\u03B7\u03C2 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03BC\u03B5\u03B3\u03AD\u03B8\u03BF\u03C5\u03C2",
  "select": "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE",
  "selectAll": "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD",
  "sortable": "\u03A3\u03C4\u03AE\u03BB\u03B7 \u03B4\u03B9\u03B1\u03BB\u03BF\u03B3\u03AE\u03C2"
};
export { $ac03861c6e8605f4$exports as default };